/**
 * Resolves JSON Pointer values in form maps (embedded-table filter / actionParamMap).
 * Values like "#/properties/planGrantDocumentId" become live form field values.
 */
export function resolveFormPointerMap(
  map: Record<string, unknown> | undefined,
  formValues: Record<string, unknown>,
): Record<string, unknown> | undefined {
  if (map == null) return undefined;
  const resolved: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(map)) {
    if (typeof value === 'string' && value.startsWith('#/properties/')) {
      const fieldPath = value.replace(/^#\/properties\//, '').replace(/\/properties\//g, '.');
      resolved[key] = formValues[fieldPath];
    } else {
      resolved[key] = value;
    }
  }
  return resolved;
}

/** Collect RHF field paths to watch for reactive pointer resolution. */
export function collectFormPointerWatchPaths(map: Record<string, unknown> | undefined): string[] {
  if (map == null) return [];
  return Object.values(map)
    .filter((v): v is string => typeof v === 'string' && v.startsWith('#/properties/'))
    .map((v) => v.replace(/^#\/properties\//, '').replace(/\/properties\//g, '.'));
}
